// The navbar's text links beside its icons, Tencent Cloud's and Aliyun's
// 费用 and 工单 — the part of the navbar that differs between the consoles
// (App.vue is the same file in both; the account is NavAccount).
import type { Component } from 'vue'
import NavBilling from '@/components/navbar/NavBilling.vue'
import NavTickets from '@/components/navbar/NavTickets.vue'
import AssistantHost from '@/components/assistant/AssistantHost.vue'
import AssistantNavButton from '@/components/assistant/AssistantNavButton.vue'

export interface NavLink {
  route: string
  /** An i18n key. */
  label: string
  /** A link with a panel under it draws itself (NavMenu: its cell and the panel). */
  panel?: Component
}

export const NAV_LINKS: NavLink[] = [
  { route: 'billing', label: 'navbar.billing', panel: NavBilling },
  { route: 'tickets', label: 'navbar.tickets', panel: NavTickets },
]

// What floats over this console's pages: the AI 助手 (its button and panel).
export const OVERLAYS: Component[] = [AssistantHost]

// What stands in the navbar right of the search box: the AI 助手, when the
// admin offers it there.
export const NAV_EXTRAS: Component[] = [AssistantNavButton]
